import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { attachmentTypeToIcon, formatFileSize } from '@utils/AttachmentUtils';
import ClearIcon from '@mui/icons-material/Clear';
import { useContext } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { refineFonts } from '@/Theming/refineFonts';

type AttachmentItemProps = {
	attachmentId: string;
	attachmentName: string;
	attachmentSize: number;
	attachmentType: string;
	deleteAttachment: (id: string) => void;
	abortAttachmentUpload: (attachmentName: string) => void;
	isLoading?: boolean;
};

export const UploadAttachmentItem = ({
	attachmentId,
	attachmentName,
	attachmentType,
	attachmentSize,
	deleteAttachment,
	abortAttachmentUpload,
	isLoading = false,
}: AttachmentItemProps) => {
	const handleDeleteAttachment = async (event: any) => {
		if (isLoading) {
			abortAttachmentUpload(attachmentName);
			return;
		}
		event.stopPropagation();
		deleteAttachment(attachmentId);
	};
	const { A11Y } = useContext(LocalizationContext);

	return (
		<div
			tabIndex={0}
			aria-label={`${A11Y.UploadedFile} ${attachmentName}`}
			style={{ position: 'relative' }}
			data-cy={`pqUploadAttachmentItem_${attachmentId}`}>
			<Stack sx={{ backgroundColor: '#EEEEEE', height: '40px', borderRadius: '5px' }}>
				<Stack gap={'4px'} flex={1} padding={'5px'} alignItems={'center'} direction={'row'}>
					<Stack direction={'row'} flex={1} alignItems={'center'} gap={'4px'}>
						<Box display={'flex'}>{attachmentTypeToIcon[attachmentType]}</Box>
						<Typography
							maxWidth={{
								xxs: '200px',
								xs: '250px',
								sm: '100%',
								md: '100%',
								lg: '100%',
							}}
							noWrap
							sx={{ ...refineFonts.mediumRegular }}>
							{attachmentName}
						</Typography>
					</Stack>
					<Stack
						sx={{ cursor: 'pointer' }}
						alignItems={'center'}
						direction={'row'}
						onClick={handleDeleteAttachment}>
						<Typography
							width={'50px'}
							whiteSpace={'nowrap'}
							sx={{ ...refineFonts.mediumRegular }}
							color={'#585858'}>
							({formatFileSize(attachmentSize)})
						</Typography>

						<div style={{ display: 'flex' }} data-cy={`pqUploadAttachmentItemDeleteButton_${attachmentId}`}>
							<ClearIcon sx={{ color: 'rgba(0,0,0,0.54)' }} />
						</div>
					</Stack>
				</Stack>
				{isLoading && (
					<Box>
						<LinearProgress sx={{ borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px' }} />
					</Box>
				)}
			</Stack>
		</div>
	);
};
